import { createAction, props } from '@ngrx/store';

export const setAssistenceValueRelatedAction = createAction(
  '[ASSISTENCEVALUE] Set Assistence value',
  props<{ assistenceValueRelated: number }>()
);
